export const getProjectsByCategory = (projects: any, category: string) => {
  return projects.filter((project: any) => project.categories.includes(category));
};